// HomeEleccionEdit.js
import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Skeleton, Stack, Typography } from "@mui/material";
import icono_elemento_1 from "../../../images/icono_elemento_1.png";
import icono_elemento_2 from "../../../images/icono_elemento_2.png";
import icono_elemento_3 from "../../../images/icono_elemento_3.png";
import icono_elemento_4 from "../../../images/icono_elemento_4.png";
import icono_elemento_5 from "../../../images/icono_elemento_5.png";

function getColorForSection(colorClass) {
	switch (colorClass) {
		case "":
			return { titleColor: "#4f9ee1", descColor: "#4f9ee1" };
		case "back-mora":
			return { titleColor: "#9c5adf", descColor: "#9c5adf" };
		case "back-nr":
			return { titleColor: "#f69435", descColor: "#f69435" };
		case "back-red":
			return { titleColor: "#dc3b3b", descColor: "#dc3b3b" };
		case "back-green":
			return { titleColor: "#1a9d46", descColor: "#1a9d46" };
		default:
			return { titleColor: "#4f9ee1", descColor: "#4f9ee1" };
	}
}

const HomeEleccionEdit = ({ keyBranch, empresaDetails, updateWhyChooseUs, isLoading }) => {
	const [sections, setSections] = useState([]);
	const [editing, setEditing] = useState(null);
	const [tempVal, setTempVal] = useState("");

	useEffect(() => {
		if (keyBranch !== null && empresaDetails !== null) {
			initializeSectionsFromApi();
		}
	}, [empresaDetails, keyBranch]);
	const handleKeyDown = (e) => {
		if (e.key === "Enter" && !e.shiftKey) {
			e.preventDefault();
			saveEdit();
		}
	};
	const startEditing = (sectionIndex, field, initialVal) => {
		if (editing && (editing.sectionIndex !== sectionIndex || editing.field !== field)) {
			setEditing(null);
		}
		setEditing({ sectionIndex, field });
		setTempVal(initialVal);
	};

	const initializeSectionsFromApi = () => {
		const why_choose_us = empresaDetails || {};
		const updatedSections = [
			{
				colorClass: "",
				number: "01",
				titleFooter: "Experiencia",
				icon: icono_elemento_1,
				configKey: "experience",
				main_title: why_choose_us.experience?.main_title,
				main_text: why_choose_us.experience?.main_text,
				secondary_title: why_choose_us.experience?.secondary_title,
				secondary_text: why_choose_us.experience?.secondary_text,
				enabled: why_choose_us.experience?.enabled,
			},
			{
				colorClass: "back-mora",
				number: "02",
				titleFooter: "Satisfacción",
				icon: icono_elemento_2,
				configKey: "satisfaction",
				main_title: why_choose_us.satisfaction?.main_title,
				main_text: why_choose_us.satisfaction?.main_text,
				secondary_title: why_choose_us.satisfaction?.secondary_title,
				secondary_text: why_choose_us.satisfaction?.secondary_text,
				enabled: why_choose_us.satisfaction?.enabled,
			},
			{
				colorClass: "back-nr",
				number: "03",
				titleFooter: "Cobertura",
				icon: icono_elemento_3,
				configKey: "coverage",
				main_title: why_choose_us.coverage?.main_title,
				main_text: why_choose_us.coverage?.main_text,
				secondary_title: why_choose_us.coverage?.secondary_title,
				secondary_text: why_choose_us.coverage?.secondary_text,
				enabled: why_choose_us.coverage?.enabled,
			},
			{
				colorClass: "back-red",
				number: "04",
				titleFooter: "Calidad",
				icon: icono_elemento_4,
				configKey: "quality",
				main_title: why_choose_us.quality?.main_title,
				main_text: why_choose_us.quality?.main_text,
				secondary_title: why_choose_us.quality?.secondary_title,
				secondary_text: why_choose_us.quality?.secondary_text,
				enabled: why_choose_us.quality?.enabled,
			},
			{
				colorClass: "back-green",
				number: "05",
				titleFooter: "Nobleza",
				icon: icono_elemento_5,
				configKey: "nobility",
				main_title: why_choose_us.nobility?.main_title,
				main_text: why_choose_us.nobility?.main_text,
				secondary_title: why_choose_us.nobility?.secondary_title,
				secondary_text: why_choose_us.nobility?.secondary_text,
				enabled: why_choose_us.nobility?.enabled,
			},
		];
		setSections(updatedSections);
	};
	const saveEdit = () => {
		const { sectionIndex, field } = editing;
		setSections((prev) => {
			const newSections = [...prev];
			const targetSec = { ...newSections[sectionIndex] };
			targetSec[field] = tempVal;
			newSections[sectionIndex] = targetSec;
			return newSections;
		});
		const configKey = sections[sectionIndex].configKey;
		const updatedData = {
			[configKey]: {
				[field]: tempVal,
			},
		};
		if (typeof updateWhyChooseUs === "function") {
			updateWhyChooseUs(updatedData);
		}

		setEditing(null);
	};
	const cancelEdit = () => {
		setEditing(null);
		setTempVal("");
	};
	const toggleSectionEnabled = (sectionIndex) => {
		const section = sections[sectionIndex];
		const configKey = section.configKey;
		const newEnabledValue = !section.enabled;

		setSections((prev) => {
			const newSections = [...prev];
			newSections[sectionIndex] = {
				...newSections[sectionIndex],
				enabled: newEnabledValue,
			};
			return newSections;
		});
		const updatedData = {
			[configKey]: {
				enabled: newEnabledValue,
			},
		};
		if (typeof updateWhyChooseUs === "function") {
			updateWhyChooseUs(updatedData);
		}
	};
	const getCharLimit = (fieldType) => {
		if (fieldType.includes("title")) {
			return 30;
		} else {
			return 80;
		}
	};
	const handleChange = (e) => {
		const val = e.target.value;
		const maxLength = getCharLimit(editing.field);

		if (val.length <= maxLength) {
			setTempVal(val);
		}
	};
	if (!sections || sections.length === 0) {
		return (
			<div className="fondo_eleccion">
				<div className="overlay-eleccion"></div>
				<div className="content-eleccion">
					<div className="data-container">
						<Skeleton variant="rounded" width={180} height={40} />
					</div>

					<div className="card-eleccion">
						<div className="seccion-top">
							{/* Top section skeletons - 3 cards */}
							{[...Array(3)].map((_, index) => (
								<div key={index} className={`seccion-eleccion ${index === 2 ? "eleccion-tres" : ""}`}>
									<Box
										sx={{
											bgcolor: "rgba(255, 255, 255, 0.15)",
											borderRadius: "10px",
											p: 2,
											width: "100%",
											height: "100%",
										}}>
										{/* Circle icon skeleton */}
										<Box display="flex" justifyContent="center" mb={2}>
											<Skeleton variant="circular" width={60} height={60} />
										</Box>

										{/* Content skeleton */}
										<Box mb={2}>
											<Skeleton variant="text" sx={{ fontSize: "1rem", mb: 1 }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "1rem", mt: 1, mb: 1 }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
										</Box>

										{/* Footer skeleton */}
										<Box display="flex" alignItems="center" gap={1}>
											<Skeleton variant="text" width={30} height={30} />
											<Skeleton variant="text" width={100} height={20} />
										</Box>
									</Box>
								</div>
							))}
						</div>

						<div className="seccion-bottom">
							{/* Bottom section skeletons - 2 cards */}
							{[...Array(2)].map((_, index) => (
								<div key={index} className="seccion-eleccion">
									<Box
										sx={{
											bgcolor: "rgba(255, 255, 255, 0.15)",
											borderRadius: "10px",
											p: 2,
											width: "100%",
											height: "100%",
										}}>
										{/* Circle icon skeleton */}
										<Box display="flex" justifyContent="center" mb={2}>
											<Skeleton variant="circular" width={60} height={60} />
										</Box>

										{/* Content skeleton */}
										<Box mb={2}>
											<Skeleton variant="text" sx={{ fontSize: "1rem", mb: 1 }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "1rem", mt: 1, mb: 1 }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
											<Skeleton variant="text" sx={{ fontSize: "0.875rem" }} />
										</Box>

										{/* Footer skeleton */}
										<Box display="flex" alignItems="center" gap={1}>
											<Skeleton variant="text" width={30} height={30} />
											<Skeleton variant="text" width={100} height={20} />
										</Box>
									</Box>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className="fondo_eleccion">
			<div className="overlay-eleccion"></div>

			<div className="content-eleccion">
				<div className="data-container">
					<span className="btn-eleccion">¿Por qué elegirnos?</span>
				</div>

				<div className="card-eleccion">
					<div className="seccion-top">
						{/* Renderamos las 3 primeras secciones en la \"top\" */}
						{sections.slice(0, 3).map((section, sIdx) => {
							const { titleColor, descColor } = getColorForSection(section.colorClass);
							return (
								<div key={sIdx} className={`seccion-eleccion ${sIdx === 2 ? "eleccion-tres" : ""}`}>
									<div className={`card-experiencia ${section.colorClass}`}>
										<div className={`card-arrow ${section.colorClass.replace("back", "arrow")}`} />
										<div className={`circle-space ${section.colorClass}`}>
											<img src={section.icon} alt="icon" />
										</div>
										<div className="card-content">
											<ul>
												<li>
													{/* Título Principal */}
													{editing &&
													editing.sectionIndex === sIdx &&
													editing.field === "main_title" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																slotProps={{
																	htmlInput: {
																		maxLength: 30,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Typography
																variant="caption"
																sx={{
																	display: "block",
																	textAlign: "right",
																	color:
																		tempVal.length >= getCharLimit(editing.field)
																			? "error.main"
																			: "text.secondary",
																	mt: 0.5,
																}}>
																{tempVal.length}/{getCharLimit(editing.field)}{" "}
																caracteres
															</Typography>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<strong
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: titleColor,
																display: "block",
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "1.5em",
															}}
															onClick={() =>
																startEditing(sIdx, "main_title", section.main_title)
															}>
															· {section.main_title}
														</strong>
													)}
													<br />

													{/* Texto Principal */}
													{editing &&
													editing.sectionIndex === sIdx &&
													editing.field === "main_text" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																slotProps={{
																	htmlInput: {
																		maxLength: 80,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Typography
																variant="caption"
																sx={{
																	display: "block",
																	textAlign: "right",
																	color:
																		tempVal.length >= getCharLimit(editing.field)
																			? "error.main"
																			: "text.secondary",
																	mt: 0.5,
																}}>
																{tempVal.length}/{getCharLimit(editing.field)}{" "}
																caracteres
															</Typography>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<p
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: descColor,
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "4em",
															}}
															onClick={() =>
																startEditing(sIdx, "main_text", section.main_text)
															}>
															{section.main_text}
														</p>
													)}
												</li>
												<li>
													{/* Título Secundario */}
													{editing &&
													editing.sectionIndex === sIdx &&
													editing.field === "secondary_title" ? (
														<Box>
															<TextField
																slotProps={{
																	htmlInput: {
																		maxLength: 30,
																	},
																}}
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Typography
																variant="caption"
																sx={{
																	display: "block",
																	textAlign: "right",
																	color:
																		tempVal.length >= getCharLimit(editing.field)
																			? "error.main"
																			: "text.secondary",
																	mt: 0.5,
																}}>
																{tempVal.length}/{getCharLimit(editing.field)}{" "}
																caracteres
															</Typography>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<strong
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: titleColor,
																display: "block",
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "1.5em",
															}}
															onClick={() =>
																startEditing(
																	sIdx,
																	"secondary_title",
																	section.secondary_title
																)
															}>
															· {section.secondary_title}
														</strong>
													)}
													<br />

													{/* Texto Secundario */}
													{editing &&
													editing.sectionIndex === sIdx &&
													editing.field === "secondary_text" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																slotProps={{
																	htmlInput: {
																		maxLength: 80,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Typography
																variant="caption"
																sx={{
																	display: "block",
																	textAlign: "right",
																	color:
																		tempVal.length >= getCharLimit(editing.field)
																			? "error.main"
																			: "text.secondary",
																	mt: 0.5,
																}}>
																{tempVal.length}/{getCharLimit(editing.field)}{" "}
																caracteres
															</Typography>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<p
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: descColor,
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "4em",
															}}
															onClick={() =>
																startEditing(
																	sIdx,
																	"secondary_text",
																	section.secondary_text
																)
															}>
															{section.secondary_text}
														</p>
													)}
												</li>
											</ul>
										</div>
										<div className="card-footer one-footer-card">
											<span className="number-card-company">{section.number}</span>
											<span className="title">{section.titleFooter}</span>

											<Button
												variant={section.enabled ? "contained" : "outlined"}
												color={section.enabled ? "primary" : "error"}
												size="small"
												onClick={(e) => {
													e.stopPropagation();
													toggleSectionEnabled(sIdx);
												}}
												sx={{
													position: "absolute",
													right: "20px",
													bottom: "10px",
													fontSize: "11px",
													minWidth: "85px",
												}}>
												{section.enabled ? "Activado" : "Desactivado"}
											</Button>
										</div>
									</div>
								</div>
							);
						})}
					</div>

					<div className="seccion-bottom">
						{sections.slice(3, 5).map((section, sIdx2) => {
							const realIndex = sIdx2 + 3; // offset
							const { titleColor, descColor } = getColorForSection(section.colorClass);

							return (
								<div key={realIndex} className="seccion-eleccion">
									<div className={`card-experiencia ${section.colorClass}`}>
										<div className={`card-arrow ${section.colorClass.replace("back", "arrow")}`} />
										<div className={`circle-space ${section.colorClass}`}>
											<img src={section.icon} alt="icon" />
										</div>
										<div className="card-content">
											<ul>
												<li>
													{/* Título Principal */}
													{editing &&
													editing.sectionIndex === realIndex &&
													editing.field === "main_title" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onKeyDown={handleKeyDown}
																onChange={handleChange}
																slotProps={{
																	htmlInput: {
																		maxLength: 30,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<strong
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: titleColor,
																display: "block",
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "1.5em",
															}}
															onClick={() =>
																startEditing(
																	realIndex,
																	"main_title",
																	section.main_title
																)
															}>
															· {section.main_title}
														</strong>
													)}
													<br />

													{/* Texto Principal */}
													{editing &&
													editing.sectionIndex === realIndex &&
													editing.field === "main_text" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																multiline
																rows={2}
																slotProps={{
																	htmlInput: {
																		maxLength: 80,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "12px",
																		color: descColor,
																	},
																	"mt": 1,
																}}
															/>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<p
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: descColor,
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "4em",
															}}
															onClick={() =>
																startEditing(realIndex, "main_text", section.main_text)
															}>
															{section.main_text}
														</p>
													)}
												</li>
												<li>
													{/* Título Secundario */}
													{editing &&
													editing.sectionIndex === realIndex &&
													editing.field === "secondary_title" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onKeyDown={handleKeyDown}
																onChange={handleChange}
																slotProps={{
																	htmlInput: {
																		maxLength: 30,
																	},
																}}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "14px",
																		fontWeight: "bold",
																		color: titleColor,
																	},
																	"mt": 1,
																}}
															/>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<strong
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: titleColor,
																display: "block",
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "1.5em",
															}}
															onClick={() =>
																startEditing(
																	realIndex,
																	"secondary_title",
																	section.secondary_title
																)
															}>
															· {section.secondary_title}
														</strong>
													)}
													<br />

													{/* Texto Secundario */}
													{editing &&
													editing.sectionIndex === realIndex &&
													editing.field === "secondary_text" ? (
														<Box>
															<TextField
																fullWidth
																value={tempVal}
																onChange={handleChange}
																onKeyDown={handleKeyDown}
																multiline
																slotProps={{
																	htmlInput: {
																		maxLength: 80,
																	},
																}}
																rows={2}
																sx={{
																	"& .MuiInputBase-root": {
																		fontSize: "12px",
																		color: descColor,
																	},
																	"mt": 1,
																}}
															/>
															<Box mt={1} display="flex" gap={1}>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="contained"
																	disabled={isLoading}
																	loading={isLoading}
																	onClick={saveEdit}>
																	Guardar
																</Button>
																<Button
																	sx={{ fontSize: "12px" }}
																	variant="outlined"
																	onClick={cancelEdit}>
																	Cancelar
																</Button>
															</Box>
														</Box>
													) : (
														<p
															className={section.colorClass.replace("back-", "")}
															style={{
																cursor: "pointer",
																color: descColor,
																wordWrap: "break-word",
																hyphens: "auto",
																minHeight: "4em",
															}}
															onClick={() =>
																startEditing(
																	realIndex,
																	"secondary_text",
																	section.secondary_text
																)
															}>
															{section.secondary_text}
														</p>
													)}
												</li>
											</ul>
										</div>
										<div className="card-footer">
											<span className="number-card-company">{section.number}</span>
											<Stack spacing={1}>
												<span className="title">{section.titleFooter}</span>
												<Button
													variant={section.enabled ? "contained" : "outlined"}
													color={section.enabled ? "primary" : "default"}
													size="small"
													onClick={() => toggleSectionEnabled(realIndex)}
													sx={{ ml: 2, fontSize: "10px" }}>
													{section.enabled ? "Activado" : "Desactivado"}
												</Button>
											</Stack>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};
export default HomeEleccionEdit;
